// src/pages/Public/ResetPassword.jsx
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { FaLock } from 'react-icons/fa';
import axios from '../../api/axios';

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [tokenValid, setTokenValid] = useState(true);
    const [verifying, setVerifying] = useState(true);

    useEffect(() => {
        verifyToken();
    }, [token]);

    const verifyToken = async () => {
        try {
            await axios.get(`/auth/verify-token/${token}/`);
            setTokenValid(true);
        } catch (err) {
            setTokenValid(false);
            setError('Ce lien est invalide ou a expiré.');
        } finally {
            setVerifying(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password.length < 6) {
            setError('Le mot de passe doit contenir au moins 6 caractères');
            return;
        }

        if (password !== confirmPassword) {
            setError('Les mots de passe ne correspondent pas');
            return;
        }

        setLoading(true);
        setError('');

        try {
            await axios.post('/auth/reset-password/', {
                token,
                password,
                confirm_password: confirmPassword
            });
            setSuccess('Mot de passe réinitialisé avec succès ! Redirection...');
            setTimeout(() => navigate('/login'), 2000);
        } catch (err) {
            setError(err.response?.data?.error || 'Une erreur est survenue');
        } finally {
            setLoading(false);
        }
    };

    if (verifying) {
        return (
            <div className="d-flex justify-content-center align-items-center min-vh-100">
                <Spinner animation="border" />
            </div>
        );
    }

    if (!tokenValid) {
        return (
            <Container>
                <Row className="justify-content-center align-items-center min-vh-100">
                    <Col lg={4} md={6} sm={8} xs={11}>
                        <Card className="shadow-lg">
                            <Card.Body className="p-4 text-center">
                                <h3>❌ Lien invalide</h3>
                                <p>{error}</p>
                                <Link to="/forgot-password">Demander un nouveau lien</Link>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <div className="reset-password-page">
            <Container>
                <Row className="justify-content-center align-items-center min-vh-100">
                    <Col lg={4} md={6} sm={8} xs={11}>
                        <Card className="shadow-lg">
                            <Card.Body className="p-4">
                                <h3 className="text-center mb-4">Nouveau mot de passe</h3>

                                {error && <Alert variant="danger">{error}</Alert>}
                                {success && <Alert variant="success">{success}</Alert>}

                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3">
                                        <div className="input-wrapper">
                                            <FaLock className="input-icon" />
                                            <Form.Control
                                                type="password"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                placeholder="Nouveau mot de passe"
                                                required
                                            />
                                        </div>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <div className="input-wrapper">
                                            <FaLock className="input-icon" />
                                            <Form.Control
                                                type="password"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                placeholder="Confirmer le mot de passe"
                                                required
                                            />
                                        </div>
                                    </Form.Group>

                                    <Button type="submit" disabled={loading} className="w-100">
                                        {loading ? <Spinner animation="border" size="sm" /> : 'Réinitialiser'}
                                    </Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ResetPassword;